// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutShippingAddressesStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingAddresses";
import { getProp } from "@insite/mobius/utilities";
import { addressInfoDisplayStyles } from "@monsma/App/ComponentExtensions/AddressInfoDisplayExtension";
import { addressWrapper } from "@monsma/App/WidgetExtensions/Addresses/SharedAddressesComponentsStylesExtension";
import MapMarkerAlt from "@monsma/XDL/Icons/MapMarkerAlt";
import { css } from "styled-components";

checkoutShippingAddressesStyles.container = {
    css: css`
        margin-bottom: 50px;
    `,
};

checkoutShippingAddressesStyles.billingAddress = {
    selectSavedAddressLink: {
        css: css`
            display: none;
        `,
    },
    addressDisplayAndFormGridItem: {
        css: css`
            flex-direction: column;
            align-items: stretch;
        `,
    },
    headingText: {
        variant: "h4",
    },
    addressDisplay: {
        wrapper: {
            css: css`
                ${addressInfoDisplayStyles.wrapper?.css}
                ${addressWrapper.css}
            `,
        },
    },
};

checkoutShippingAddressesStyles.shippingAddress = {
    selectSavedAddressLink: {
        icon: {
            iconProps: {
                src: MapMarkerAlt,
                size: 12,
                color: "common.ui5",
            },
            position: "left",
        },
        css: css`
            margin-left: 20px;
            ${getProp("theme.link.defaultProps.css")};
        `,
    },

    addressDisplayAndFormGridItem: {
        css: css`
            flex-direction: column;
            align-items: stretch;
        `,
    },
    headingText: {
        variant: "h4",
    },
    addressDisplay: {
        wrapper: {
            css: css`
                ${addressInfoDisplayStyles.wrapper?.css}
                ${addressWrapper.css}
            `,
        },
    },
};

checkoutShippingAddressesStyles.pickUpAddress = {
    findLocationLink: checkoutShippingAddressesStyles.shippingAddress.selectSavedAddressLink,
    headingText: checkoutShippingAddressesStyles.shippingAddress.headingText,
    selectedLocationAddressDisplay: checkoutShippingAddressesStyles.shippingAddress.addressDisplay,
    selectedLocationName: {
        variant: "h6",
    },
};
